// oxlint-disable complexity
import { TarifgruppeSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/TarifvertragFields/TarifgruppeSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Standort } from '@/domain/mitarbeiter/features/anlageassistent/entities/Standort';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line max-lines-per-function
export function TarifvertragFields({
  standort,
  showGehalt,
}: {
  standort: Standort;
  showGehalt: boolean;
}) {
  const form = useAnlageassistentFormContext();

  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <h2 className="text-neutrals-900 text-base font-bold leading-6">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.title',
          )}
        </h2>
        {showGehalt ? (
          <span className="text-neutrals-800 text-sm font-normal leading-5">
            {t(
              'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.descriptionFixgehalt',
            )}
          </span>
        ) : (
          <span className="text-neutrals-800 text-sm font-normal leading-5">
            {t(
              'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.descriptionStunden',
            )}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <div className="grid lg:grid-cols-2 gap-4 items-start ">
          <TarifgruppeSelect standort={standort} />
          <form.Subscribe
            selector={(state) => ({
              tarifgruppe: state.values.bezahlung.bezahlungsart.tarifGruppe,
            })}>
            {({ tarifgruppe }) => {
              const selectedTarifgruppe =
                standort.tarifvertrag?.tarifgruppen.find(
                  (tg) => tg.id === tarifgruppe,
                );

              return (
                <div
                  className={cn(
                    'grid lg:grid-cols-2 gap-4 items-start',
                    showGehalt ? 'col-span-2' : 'lg:grid-cols-1',
                  )}>
                  {(selectedTarifgruppe || tarifgruppe === 'keine') && (
                    <form.AppField name="bezahlung.bezahlungsart.stundenlohn">
                      {(field) => (
                        <field.MoneyInput
                          disabled={!!selectedTarifgruppe}
                          label={t(
                            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.stundenlohn.label',
                          )}
                          isRequired
                        />
                      )}
                    </form.AppField>
                  )}
                  {showGehalt &&
                    (selectedTarifgruppe || tarifgruppe === 'keine') && (
                      <form.AppField name="bezahlung.bezahlungsart.monatsgehalt">
                        {(field) => (
                          <field.MoneyInput
                            disabled={!!selectedTarifgruppe}
                            label={t(
                              'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.monatsgehalt.label',
                            )}
                          />
                        )}
                      </form.AppField>
                    )}
                </div>
              );
            }}
          </form.Subscribe>
        </div>
      </div>
    </div>
  );
}
